module.exports = __webpack_public_path__ + "static/media/55_000067.0e9b0da7.jpg";